import type { LinkItem } from './types';

/*
 * Source: https://www.nsave.com/terms/terms-conditions (fetched live).
 * Individual legal documents are served in-app under the same Webflow paths
 * (e.g. /terms/membership-agreement) from Payload CMS, with static fallback.
 * Cookie Policy remains the dedicated /terms/cookie route.
 */

export interface TermsGroup {
  title: string;
  links: LinkItem[];
}

export const termsContent = {
  title: 'Terms & Conditions',
  lastUpdated: '8 January 2026',
  intro: [
    'The hyperlinks below provide information on the terms and conditions that apply to the use of our website, mobile app, products and services.',
    'By downloading our mobile app and using our products and services, you agree to the terms and conditions below.',
  ],
  groups: [
    {
      title: 'Key Terms',
      links: [
        { label: 'Membership Agreement', href: '/terms/membership-agreement' },
        { label: 'App Terms & Conditions', href: '/terms/application' },
      ],
    },
    {
      title: 'Modules',
      links: [
        { label: 'Card Funding Terms', href: '/terms/card-funding-terms-conditions' },
        { label: 'Spend Card Terms', href: '/terms/card-terms' },
        { label: 'USD Wallet Terms', href: '/terms/usd-wallet-terms' },
        { label: 'Business Terms & Conditions', href: '/terms/business-terms-conditions' },
      ],
    },
    {
      title: 'Other Terms',
      links: [
        { label: 'Website Terms & Conditions', href: '/terms/general' },
        { label: 'Business Accounts Terms & Conditions', href: '/terms/account/corporate' },
        { label: 'Rewards Terms & Conditions', href: '/terms/rewards' },
        { label: 'Fees & Charges Policy', href: '/terms/fees' },
        { label: 'Cookie Policy', href: '/terms/cookie' },
      ],
    },
  ] satisfies TermsGroup[],
};
